import React from "react";

interface Option {
    value: string | number;
    label: string;
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    options: Option[];
    onClick?: () => void;
    className?: string;
    props?: React.SelectHTMLAttributes<HTMLSelectElement>;
}

const Select: React.FC<SelectProps> = ({ options, onClick, className, ...props }) => (
    <select
        onClick={onClick}
        className={`px-2 py-1 bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${className}`}
        {...props}
    >
        {options.map((option, index) => (
            <option key={index} value={option.value}>
                {option.label}
            </option>
        ))}
    </select>
);

export default Select;
// Usage example:
// <Select
//   options={[
//     { value: "option1", label: "Option 1" },
//     { value: "option2", label: "Option 2" },
//     { value: "option3", label: "Option 3" },
//   ]}
//   onChange={handleChange}
//   className="w-full"
// />
//  // This component can be used in forms or anywhere a select dropdown is needed.
// It accepts an options array for options, onClick for additional functionality, and className for styling.
